export default __webpack_public_path__ + "static/media/Hristo Popov.145fa837.png";